<ng-container *ngIf="header.collapsible; else normalHeader">
  <soho-expandable-area [closed]="header.isInitiallyCollapsed">
    <soho-expandable-header>
      <div [class.col-header-container]="header.collapsible" soho-tooltip [content]="title">
        <ng-container *ngTemplateOutlet="headerFormatting"></ng-container>
        <button soho-button="tertiary" class="collapsible-header-toggle" [class.on-search]="collapsibleOnSearch" (click)="onClick($event, true)">
          <svg soho-icon [icon]="buttonIcon" class="icon"></svg>
        </button>
      </div>
      <hr class="fieldset-hr collapsible-header-hr">
    </soho-expandable-header>
    <soho-expandable-pane>
      <lm-form-layout
        [formSpec]="formSpec"
        [formOptions]="formOptions"
        [specFields]="specFields"
        [layout]="layoutObject.members"
        [model]="model"
        [formState]="formState"
        [placeHolder]="placeHolder"
        [activatedTabChanged]="activatedTabChanged"
        [formPersonalization]="formPersonalization"
        [parentIsModal]="parentIsModal"
        (fieldEvent)="onFieldEvent($event)"
      ></lm-form-layout>
      <hr class="fieldset-hr collapsible-header-hr">
    </soho-expandable-pane>
  </soho-expandable-area>
</ng-container>
<ng-template #normalHeader>
  <ng-container *ngTemplateOutlet="headerFormatting"></ng-container>
</ng-template>

<ng-template #headerFormatting >
  <div *ngIf="!header.nestedHeader && !titleIsEmpty">
    <hr *ngIf="(!header.isFirst || !header.isColumnHeader) && !header.collapsible" class="fieldset-hr">
    <ng-container [ngSwitch]="size">
      <h1 *ngSwitchCase="1"
          [ngClass]="{
            'personalize-text' : personalize && !header?.textStyle.color,
            'fieldset-title lm-header-1' : true,
            'lm-column-header' : header?.isColumnHeader,
            'on-search': collapsibleOnSearch
          }"
          lm-text-style [textStyle]="header?.textStyle"
          (click)="onClick($event, true)"
      >{{title}}<ng-container *ngTemplateOutlet="collapsibleHeaderTemplate"></ng-container></h1>
      <h2 *ngSwitchCase="2"
          [ngClass]="{
            'personalize-text' : personalize && !header?.textStyle.color,
            'fieldset-title lm-header-2' : true,
            'lm-column-header' : header?.isColumnHeader,
            'on-search': collapsibleOnSearch
          }"
          lm-text-style [textStyle]="header?.textStyle"
          (click)="onClick($event, true)"
      >{{title}}<ng-container *ngTemplateOutlet="collapsibleHeaderTemplate"></ng-container></h2>
      <h3 *ngSwitchDefault
          [ngClass]="{
            'personalize-text' : personalize && !header?.textStyle.color,
            'fieldset-title lm-header-3' : true,
            'lm-column-header' : header?.isColumnHeader,
            'on-search': collapsibleOnSearch
          }"
          lm-text-style [textStyle]="header?.textStyle"
          (click)="onClick($event, true)"
      >{{title}}<ng-container *ngTemplateOutlet="collapsibleHeaderTemplate"></ng-container></h3>
      <h4 *ngSwitchCase="4"
          [ngClass]="{
            'personalize-text' : personalize && !header?.textStyle.color,
            'fieldset-title lm-header-4' : true,
            'lm-column-header' : header.isColumnHeader,
            'on-search': collapsibleOnSearch
          }"
          lm-text-style [textStyle]="header?.textStyle"
          (click)="onClick($event, true)"
      >{{title}}<ng-container *ngTemplateOutlet="collapsibleHeaderTemplate"></ng-container></h4>
      <h5 *ngSwitchCase="5"
          [ngClass]="{
            'personalize-text' : personalize && !header?.textStyle.color,
            'fieldset-title lm-header-5' : true,
            'lm-column-header' : header.isColumnHeader,
            'on-search': collapsibleOnSearch
          }"
          lm-text-style [textStyle]="header?.textStyle"
          (click)="onClick($event, true)"
      >{{title}}<ng-container *ngTemplateOutlet="collapsibleHeaderTemplate"></ng-container></h5>
    </ng-container>
  </div>

  <!-- display a line only when using header2 of "_" -->
  <div *ngIf="!header.nestedHeader && titleIsEmpty">
    <hr class="fieldset-hr">
  </div>

  <ng-container [ngSwitch]="size" *ngIf="header.nestedHeader && !titleIsEmpty">
    <h1 *ngSwitchCase="1"
        [ngClass]="{'lm-header-1' : true, 'lm-column-header' : header?.isColumnHeader}"
    >{{title}}</h1>
    <h2 *ngSwitchCase="2"
        [ngClass]="{'lm-header-2' : true, 'lm-column-header' : header?.isColumnHeader}"
    >{{title}}</h2>
    <h3 *ngSwitchDefault
        [ngClass]="{'lm-header-3' : true, 'lm-column-header' : header?.isColumnHeader}"
    >{{title}}</h3>
    <h4 *ngSwitchCase="4"
        [ngClass]="{'lm-header-4' : true, 'lm-column-header' : header.isColumnHeader}"
    >{{title}}</h4>
    <h5 *ngSwitchCase="5"
        [ngClass]="{'lm-header-5' : true, 'lm-column-header' : header?.isColumnHeader}"
    >{{title}}</h5>
  </ng-container>
</ng-template>

<ng-template #collapsibleHeaderTemplate>
  <ng-container *ngIf="header.collapsible">
    <svg *ngIf="headerError" class="icon-error icon collapsible-header-icon" focusable="false" aria-hidden="true" role="presentation">
      <use href="#icon-error"></use>
    </svg>
  </ng-container>
</ng-template>
